import { gql } from "@shared/utils";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React, { FunctionComponent, useState } from "react";

import { useGqlField } from "../../../../hooks";
import VariablePopup from "../DynamicVariables/VariablePopup";

import { DVInlineProps } from "./types";
import { VariableButton } from "./VariableButton";

const variableToName = (variable: string) => {
  switch (variable) {
    case "linePostDistanceOnCenter":
      return "Line Post Distance";
    case "cornerPostDistanceOnCenter":
      return "Corner Post Distance";
  }
  return "";
};

const EDIT_TAKEOFF_VARIABLE = gql`
  mutation UpdateDynamicVariable($id: String!, $value: String!) {
    updateDynamicVariable(input: { id: $id, takeoffVariable: $value }) {
      _id
      takeoffVariable
    }
  }
`;
const EDIT_OUTPUT = gql`
  mutation UpdateDynamicVariable($id: String!, $value: String!) {
    updateDynamicVariable(input: { id: $id, output: $value }) {
      _id
      output
    }
  }
`;
const outputs: Array<{ label: string; value: string }> = [
  {
    value: "VALUE",
    label: "Value",
  },
];

export const DVInlineTakeoffVariable: FunctionComponent<DVInlineProps> = ({
  dynamicVariable,
  productId,
  parentProductId,
  onVariableDelete,
  removeDynamicVariable,
  activeDynamicVariableId,
  setActiveDynamicVariableId,
}) => {
  const [open, setOpen] = useState(false);

  const [takeoffVariable, setTakeoffVariable] = useGqlField(
    dynamicVariable.takeoffVariable,
    dynamicVariable._id,
    EDIT_TAKEOFF_VARIABLE
  );

  const [output, setOutput] = useGqlField(
    dynamicVariable.output,
    dynamicVariable._id,
    EDIT_OUTPUT
  );

  const onModalClose = async () => {
    if (takeoffVariable === "") {
      await removeDynamicVariable?.({
        variables: {
          input: {
            id: dynamicVariable._id,
          },
        },
      });
      if (onVariableDelete) onVariableDelete(dynamicVariable._id);
    }
  };

  return (
    <VariablePopup
      actions={[]}
      title="Edit Takeoff Variable"
      dynamicVariable={dynamicVariable}
      activeDynamicVariableId={activeDynamicVariableId}
      onCancel={() => {
        setOpen(false);
        onModalClose();
      }}
      onSave={() => {
        setOpen(false);
      }}
      onClose={() => {
        setOpen(false);
      }}
      setActiveDynamicVariableId={setActiveDynamicVariableId}
      forceOpen={open}
    >
      <VariableButton
        typeLabel="Takeoff"
        variableType="TAKEOFF_VARIABLE"
        onClick={() => {
          setOpen(true);
        }}
        line1={variableToName(dynamicVariable.takeoffVariable ?? "")}
        output={dynamicVariable?.output}
      />
      <Box>
        <FormControl fullWidth sx={{ marginTop: 2 }}>
          <InputLabel>Variable</InputLabel>
          <Select
            label="Variable"
            onChange={(e, v) => {
              setTakeoffVariable(e.target.value);
            }}
            value={takeoffVariable}
          >
            <MenuItem value="linePostDistanceOnCenter">
              {variableToName("linePostDistanceOnCenter")}
            </MenuItem>
            <MenuItem value="cornerPostDistanceOnCenter">
              {variableToName("cornerPostDistanceOnCenter")}
            </MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ marginTop: 2 }}>
          <InputLabel>Output</InputLabel>
          <Select
            label="Output"
            onChange={(e, v) => {
              setOutput(e.target.value);
            }}
            value={output}
          >
            {outputs.map((o: { label: string; value: string }) => {
              return (
                <MenuItem value={o.value} key={o.value}>
                  {o.label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Box>
    </VariablePopup>
  );
};
